export default {
  compact: 'Compact',
  details: 'Details',
};
